import cx from 'classnames';
import { Controller } from 'react-hook-form';

import { TermsOfService } from 'components/Pages/Auth/TermsOfService';
import Button from 'components/shared/Button';

import { BaseSelect } from '../../../shared/BaseFormComponents/Select';
import { HookCheckbox, HookInput, HookPasswordInput } from '../../../shared/HookFormComponents';
import Icon from '../../../shared/Icon';
import RocketMoon from '../../../shared/Icon/icons/RocketMoon';
import { SignUpText } from '../SignUp/SignUpFooter';
import { useInvitationPasswordForm } from './functions';
import styles from './index.module.css';

function InvitationPasswordForm() {
  const { isPending, data, colors, error, handleCountryChange, handleSubmit, loadCountries, isValid, control } =
    useInvitationPasswordForm();

  if (isPending) {
    return <div>Loading</div>;
  }

  if (data) {
    return (
      <div className={styles.wrapper}>
        <div className={styles.colors}>
          {colors.map((name) => (
            <div key={name} className={styles[name]} />
          ))}
        </div>
        <div className={styles.content}>
          <div className={styles.text}>
            <div className={styles.title}>
              WELCOME TO <span>SAFARI PORTAL</span>
            </div>
            <div className={cx(styles.subtitle, !data.subUser && styles.agent)}>Let’s get started.</div>
            <Icon component={RocketMoon} className={styles.moon} />
          </div>
          <form onSubmit={handleSubmit} autoComplete="off" className={styles.form}>
            <div className={styles.fullName}>
              <HookInput name="firstName" control={control} label="First Name*" />
              <HookInput name="lastName" control={control} label="Last Name*" />
            </div>
            {!data.subUser && <HookInput name="companyName" control={control} label="Company*" />}
            <HookInput name="contactPhone" control={control} label="Phone Number*" />
            {!data.subUser && (
              <Controller
                name="country"
                control={control}
                render={({ field: { value, onChange }, fieldState: { error } }) => {
                  return (
                    <div>
                      <BaseSelect
                        placeholder="Country*"
                        isClearable
                        defaultOption={value}
                        loadOptions={loadCountries}
                        onChange={handleCountryChange(onChange)}
                        errorMessage={error?.message}
                        debounceTime={0}
                      />
                    </div>
                  );
                }}
              />
            )}
            <HookPasswordInput name="password" control={control} label="Password*" withRequirements />
            <HookPasswordInput name="passwordConfirmation" control={control} label="Confirm Password*" withError />

            <HookCheckbox name="accept" control={control} className={styles.accept}>
              I have read and agree to Safari Portal’s <TermsOfService />.
            </HookCheckbox>
            <Button htmlType="submit" disabled={!isValid}>
              Sign up
            </Button>
            <div className={styles.signup}>
              <SignUpText />
            </div>
            {/* <pre>{JSON.stringify(values, 0, 2)}</pre> */}
          </form>
        </div>
      </div>
    );
  }

  if (error) {
    return <div className={styles.content}>Oooops! Your link has expired.</div>;
  }
  return null;
}

export default InvitationPasswordForm;
